import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "FileService",
  controller: "File",
};

const methods = [
  "GetFileList",
  "DeleteFile",
  "Download",
  "UploadSlice",
  "CreateSuperFile"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
    Fun.prototype[path] = function(data) {
      return this.post(path, data);
    };
  });
};

const FileManagementResourcesApi = ZJApi.defineNewApi("FileManagementResourcesApi", factory);

export default FileManagementResourcesApi;
